import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

import { Button } from '@material-ui/core';

const MaterialUiClearAllFilters = ({ items, refine }) => (
  <Button onClick={() => refine(items)}>Clear All</Button>
);

const ConnectedClearAllFilters = connectCurrentRefinements(
  MaterialUiClearAllFilters
);

export default ConnectedClearAllFilters;



// WEBPACK FOOTER //
// ./src/components/Algolia/ConnectedClearAllFilters.js